import { Component, Input } from '@angular/core';

/**
 * The "Upcoming Reservations" / "Bookings" selector for a customer profile's
 * Reservations tab (PRO-1338). Rendered by each view rather than their parent
 * so it shares a row with the view's own filter checkboxes. Links are built
 * absolutely from the customer id: the two views sit at different depths and
 * the app runs with `relativeLinkResolution: 'legacy'`.
 */
@Component({
  selector: 'app-reservations-view-toggle',
  templateUrl: './reservations-view-toggle.component.html',
  styleUrls: ['./reservations-view-toggle.component.css'],
})
export class ReservationsViewToggleComponent {
  @Input() customerId: number;

  public viewLink(view: string): string[] {
    return ['/customers', this.customerId.toString(), 'reservations', view];
  }
}
